<template>
	<div class="lesson-container">
		<div class="lesson-video-wrapper">
			<video :src="data.video_main" @pause="video_pause" @playing="video_playing(1)" class="lesson-video" controls="controls" controlsList="nodownload"></video>
		</div>
		<div class="lesson-nav">
			<ul class="lesson-nav-items f-cb">
				<li class="lesson-nav-item" @click="replaceTo('/lesson-desc')">简介</li>
				<li class="lesson-nav-item" @click="replaceTo('/lesson-chapter')">章节</li>
				<li class="lesson-nav-item" @click="replaceTo('/lesson-evaluate')">评论</li>
				<li class="lesson-nav-item" @click="replaceTo('/lesson-question')">问答</li>
				<li class="lesson-nav-item" @click="replaceTo('/lesson-note')">笔记</li>
			</ul>
			<div class="lesson-nav-line"></div>
		</div>
		<dialog-mask :open="isOpsMaskShow" @click.native="hideOps"></dialog-mask>
<!--		<div class="ops" v-if="this.$store.state.isLogin">-->
		<div class="ops">
			<div class="ops-button" @click="controlOps"></div>
			<div class="ops-comment" @click="to('/comment')">评论</div>
			<div class="ops-ask" @click="to('/ask')">提问</div>
			<div class="ops-note" @click="to('/create-note')">笔记</div>
		</div>
		<div class="lesson-view">
			<router-view></router-view>
      <!--<component :is="currentTabComponent"></component>-->
		</div>
		<login-dialog :isOpen="isLoginDialogShow" @close="isLoginDialogShow=false"></login-dialog>
	</div>
</template>

<script>
	import mask from "../mask/mask.vue";
	var login_status = geturl_j('login_status');
	export default{
		data(){
			return {
				data:{},
				courseId:this.$route.params.courseId,
				id:this.$route.params.id,
				isOpsMaskShow:false,
				counter:null,
				timer:'',
				is_playing:true//视频是否正在播放
			}
		},
		created(){
			this.getData();
		},
		mounted(){
			//刚进入页面根据path设置导航高亮
			this.addActive(this.$route.path,true);
		},
		beforeRouteUpdate(to,from,next){
			//如果切换视频（不是访问同视频下其他选项卡）
			if(to.params.id!==this.id || to.params.courseId!==this.courseId){
				window.clearInterval(this.counter);
				document.querySelector(".lesson-video").pause();
				this.getData(to.params.courseId,to.params.id);
			}
			//访问同视频下其他选项卡
			else{
				//切换子路由时根据path设置导航高亮
				this.addActive(to.path);
			}
			next();
		},
		methods:{
		  //视频开始播放
      video_playing(type){
        //type 0 自调用 1点击播放按钮
        if(type){
          this.is_playing = true;
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          var whereYouAt = document.querySelector(".lesson-video").currentTime;
          this.$api.get("",{
            user_type:this.tools.getStorage("user_type"),
            //course_id:courseid,
            course_id:this.courseId,
            section_id:this.id,
            api:'/v1/schedule/update',
            current_time:whereYouAt
          },res => {
            console.log(res)
          })
          if(this.is_playing){
            this.video_playing(0)
          }
        },5000)
      },
      //视频暂停
      video_pause(){
        this.is_playing = false;
        clearTimeout(this.timer);
      },
			//获取视频信息 参数：课程id 节id
			getData(course_id,id){
				if(login_status==1){
        			if (!this.$store.state.isLogin) {
          				this.isLoginDialogShow = true;
         				return;
        			}
      			}
				id=id?id:this.$route.params.id;
				course_id=course_id?course_id:this.$route.params.courseId;
				this.$api.get("",{
					api:"/v1/course/read_section",
					id,
          course_id:this.$route.params.courseId,
          center_id:this.tools.getStorage("center_id")
				},res => {
          this.data=res.data;
          this.id=this.$route.params.id;
          this.courseId=this.courseId;
          this.$nextTick(()=>{
            this.sendRate();
            var second=0;
            document.querySelector(".lesson-video").currentTime=second;
          });
					//获取视频进度信息
					this.$api.get("",{
						api:"/v1/schedule/index",
						course_id,
						section_id:id,
						user_type:this.tools.getStorage("user_type")
					},res1 => {
						this.data=res.data;
						this.id=this.$route.params.id;
						this.courseId=this.courseId;
						this.$nextTick(()=>{
							this.sendRate();
							var second=res1.data.play_time;
              //免登录并且已登录，报名课程
              if(login_status!=1 && this.$store.state.isLogin){
                this.$api.get("",{
                  api:"/v1/baoming/create",
                  user_type:this.tools.getStorage("user_type"),
                  course_id:this.courseId
                },res=>{
                  if(res.status!=1){
                    this.$toast(res.msg);
                  }
                })
              }
							// document.querySelector(".lesson-video").currentTime=second;
              //判断是安卓还是ios
              function isAndroid(){
                var u = navigator.userAgent;
                if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
                  return true;
                }
              };
              if(isAndroid()){
                document.querySelector(".lesson-video").currentTime=second;
              }else{
                //已准备好开始播放
                document.querySelector(".lesson-video").addEventListener("canplay",function() {
                  //设置播放时间
                  document.querySelector(".lesson-video").currentTime=second;
                });
              }
						});
					});
				})
			},
			to(name){
				this.$router.push(name+"/"+this.courseId+"/"+this.$route.params.id);
			},
			replaceTo(name){
				this.$router.replace(name+"/"+this.courseId+"/"+this.$route.params.id);
			},
			addActive(path,isFirst){
				//给导航加高亮
				//参数：path：地址 用于判断给哪项导航加高亮 isFirst：是否是进入页面后第一次执行
				["desc","chapter","evaluate","question","note"].forEach((value,index)=>{
					var activeItem=document.querySelectorAll(".lesson-nav-item")[index];
					//如果是要加高亮的项
					if(path.indexOf(value)!=-1){
						//去掉所有项的active class，给高亮项加class
						document.querySelectorAll(".lesson-nav-item").forEach((itemValue)=>{
							var str="lesson-nav-item-active";
							if((itemValue.className.indexOf(str))!=-1){
								itemValue.className=itemValue.className.replace(str,"");
							}
						})
						activeItem.className+=" lesson-nav-item-active";

						//移动小横杠
						document.querySelector(".lesson-nav-line").style.left=activeItem.offsetLeft+"px";
						//初始下，小横杠隐藏并无动画效果。这是为了第一次进入页面时直接显示出来
						//如果是第一次执行，显示并将其设置为动画效果
						if(isFirst){
							document.querySelector(".lesson-nav-line").style.display="block";
							document.querySelector(".lesson-nav-line").style.transition="left .1s";
						}
						return;
					}
				})
			},
			sendRate(){
				//监听视频播放并发送进度
				//开始播放后，每过五秒发送进度
				var dom=document.querySelector(".lesson-video");
				var send=()=>{
					this.$api.get("",{
						api:"/v1/schedule/update",
						section_id:this.id,
						course_id:this.courseId,
						current_time:dom.currentTime,
						user_type:this.tools.getStorage("user_type")
					},res => {

					});

					//为了避免观看过程中到期，请求数据并保存
          // this.$api.get("",{
          //   api:'/v1/passport/refresh_token',
          //   user_type:this.tools.getStorage("user_type")
          // },res=>{
          //   if(res.status == 1){
          //     if(res.data.user_type == 2){
          //       this.tools.setCookie('center_id',res.data.center_id,3);
          //       this.tools.setCookie('mooc_tearcher_salt',res.data.salt,3);
          //       this.tools.setCookie('mooc_tearcher_token',res.data.user_token,3);
          //       this.tools.setCookie('mooc_user_id',res.data.center_id,3);
          //       this.tools.setCookie('user_type',res.data.user_type,3);
          //     }
          //     else if(res.data.user_type == 1){
          //       this.tools.setCookie('center_id',res.data.center_id,3);
          //       this.tools.setCookie('mooc_user_salt',res.data.salt,3);
          //       this.tools.setCookie('mooc_user_token',res.data.user_token,3);
          //       this.tools.setCookie('mooc_user_id',res.data.center_id,3);
          //       this.tools.setCookie('user_type',res.data.user_type,3);
          //     }
          //   }
          // });
				}
				dom.onplay=()=>{
					this.counter=window.setInterval(send,5000);
				}
				dom.onpause=()=>{
					window.clearInterval(this.counter);
				}
				//播放结束后，再发送一次进度
				dom.onended=()=>{
					window.clearInterval(this.counter);
					send();
				}
			},
			controlOps(){
				if(this.isOpsMaskShow){
					this.hideOps();
				}
				else{
					this.showOps();
				}
			},
			showOps(){
				this.isOpsMaskShow=true;
				var dom=document.querySelector(".ops");
				if(dom.className.indexOf("ops-open")==-1){
					dom.className+=" ops-open";
				}
			},
			hideOps(){
				this.isOpsMaskShow=false;
				var dom=document.querySelector(".ops");
				if(dom.className.indexOf("ops-open")!=-1){
					dom.className=dom.className.replace("ops-open","");
				}
			}
		},
		components:{
			"dialog-mask":mask
		}
	}
	//获取导航参数
	function geturl_j(name){
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
	}
</script>

<style>

	.lesson-container{
		position: fixed;
		height:100%;
		width:100%;
		display: flex;
		flex-direction: column;
	}
	.lesson-view{
		overflow-y: scroll;
		flex-grow: 1;
	}
	.lesson-video-wrapper{
		height:5.64rem;
	}
	.lesson-video{
		width:10rem;
		height:5.64rem;
		background: #000;
	}
	.lesson-nav{
		position: relative;
		background: #fff;
	}
	.lesson-nav-item{
		float:left;
		width:2rem;
		height:1.333rem;
		line-height:1.333rem;
		font-size:0.426rem;
		text-align: center;
		color:#333;
	}
	.lesson-nav-item-active{
		color:#EC6D3A;
		font-weight: bold;
		font-size:0.48rem;
	}
	.lesson-nav-line{
		display: none;
		position: absolute;
		bottom:0;
		left:-1000px;
		height:2px;
		width:2rem;
		background: #EC6D3A;
	}
	.ops{
		z-index: 100;
		position: fixed;
		bottom:0.8rem;
		right:0.8rem;
		width:1.493rem;
		height:1.493rem;
	}
	.ops-button{
		overflow: hidden;
		width:1.493rem;
		height:1.493rem;
		background: url(ops-button.png) #ec6d3a center center no-repeat;
		background-size: 0.613rem;
		border-radius: 50%;
	}
	.ops-comment,
	.ops-ask,
	.ops-note{
		display: none;
		position: absolute;
		width:1.706rem;
		height:0.64rem;
		padding-top:1.066rem;
		text-align: center;
		background: #ec6d3a center 0.24rem no-repeat;
		background-size: 0.693rem;
		border-radius: 0.133rem;
		color:#fff;
	}
	.ops-button:active,
	.ops-comment:active,
	.ops-ask:active,
	.ops-note:active{
		background-color:#ff8f62;
	}
	.ops-open .ops-comment,
	.ops-open .ops-ask,
	.ops-open .ops-note{
		display: block;
	}
	.ops-open .ops-comment{
		top:-0.226rem;
		left:-3.306rem;
		background-image: url(./ops-comment.png);
	}
	.ops-open .ops-ask{
		top:-2.52rem;
		left:-2.453rem;
		background-image: url(./ops-ask.png);
	}
	.ops-open .ops-note{
		left:-0.213rem;
		top:-3.373rem;
		background-image: url(./ops-note.png);
	}
	.infinite-scroll-text{
		height:0.533rem;
		line-height: 0.533rem;
		font-size: 0.346rem;
		text-align: center;
	}

  video::-internal-media-controls-download-button {
    display:none;
  }
  video::-webkit-media-controls-enclosure {
    overflow:hidden;
  }
  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
</style>



// WEBPACK FOOTER //
// src/components/lesson/lesson.vue